define('formkit/behavior/go.to.next.section.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');


  var GoToNextSectionBehavior = Mn.Behavior.extend({
    defaults: {
      form: null,

      eventName: 'press',

      // set to false if button visibillity should not be affected
      toggleButtonDisabled: true
    },

    initialize: function() {
      this.listenTo(this.view, this.getOption('eventName'), this.onEvent);

      if (this.getOption('toggleButtonDisabled')) {
        this.once('render', function() {
          this.view.disabled = this.isLastSection(this.getOption('form').getActiveSectionIndex());
        });

        this.listenTo(this.getOption('form'), 'change:activeSectionIndex', function(newActiveSectionIndex, oldActiveSectionIndex) {
          this.view.disabled = this.isLastSection(newActiveSectionIndex);
        });
        this.listenTo(this.getOption('form'), 'formObject:disclose', function(tempalateObjectModel, value) {
          this.view.disabled = this.isLastSection(this.getOption('form').getActiveSectionIndex());
        });
      }
    },

    onEvent: function() {
      this.goToNextSection();
    },

    goToNextSection: function() {
      var currentActiveSectionIndex = this.getOption('form').activeSectionIndex || 0;

      if (this.nextSectionExists(currentActiveSectionIndex)) {
        var nextSectionIndex = this.getNextVisibleSectionIndex(currentActiveSectionIndex);
        this.getOption('form').setActiveSectionIndex(nextSectionIndex);
      }
    },

    nextSectionExists: function(currentActiveSectionIndex) {
      var sections = this.getOption('form').getTemplateModel().get('children');
      var nextSectionIndex = this.getNextVisibleSectionIndex(currentActiveSectionIndex);
      return (nextSectionIndex > 0);
    },

    getNextVisibleSectionIndex: function(currentActiveSectionIndex) {
      var form = this.getOption('form');

      var sections = form.getTemplateModel().get('children');
      for (var i = currentActiveSectionIndex + 1; i < sections.length; i++){
        var section = sections.at(i);
        if (form.util.isVisible(section)) {
          return i;
        }
      }
      return -1;
    },

    isLastSection: function(sectionIndex) {
      return !this.nextSectionExists(sectionIndex);
    }
  });

  module.exports = GoToNextSectionBehavior;
});

